import React from 'react';
import './Footer.css';
// Import des images de certification
import qualiopiLogo from '../images/qualiopi.png';
import cpfLogo from '../images/cpf.png';
import { trackCTA, trackOutboundClick } from '../services/trackingService';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer_content">
                <div className="container">
                    <div className="row">

                        {/* Footer About */}
                        <div className="col-lg-3 footer_col">
                            <div className="footer_about">
                                <div className="footer_logo">
                                    <a href="/" onClick={(e) => { e.preventDefault(); trackCTA('logo_footer', 'Footer', 'scroll_to_top'); window.scrollTo(0, 0); }}>
                                        <div>New<span>School</span></div>
                                        <div>Centre de formation linguistique</div>
                                    </a>
                                </div>
                                <div className="footer_about_text">
                                    <p>Pour en savoir plus, vous pouvez consulter nos catalogues en ligne ou nous contacter pour un rendez-vous téléphonique.</p>
                                    <div className="footer_certifications" aria-label="Certifications & Financements">
                                        <img src={qualiopiLogo} loading="lazy" decoding="async" alt="Certification Qualiopi" className="cert-logo qualiopi" width="150" height="60" />
                                        <img src={cpfLogo} loading="lazy" decoding="async" alt="Logo Mon Compte Formation (CPF)" className="cert-logo cpf" width="60" height="60" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Footer Contact Info */}
                        <div className="col-lg-3 footer_col">
                            <div className="footer_contact">
                                <div className="footer_title">Contact</div>
                                <ul className="contact_list">
                                    <li>
                                        <a href="tel:0767428860" onClick={() => trackCTA('footer_phone', 'Footer', 'phone_call')}>07 67 42 88 60</a>
                                    </li>
                                    <li>
                                        <a href="mailto:contact@new-school.fr" onClick={() => trackCTA('footer_email', 'Footer', 'email_click')}>contact@new-school.fr</a>
                                    </li>
                                    <li>
                                        <a href="/pdf/CGV.pdf" target="_blank" rel="noopener noreferrer" onClick={() => trackCTA('footer_cgv', 'Footer', 'pdf_download')}>
                                            Conditions générales de vente
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Footer Locations */}
                        <div className="col-lg-3 footer_col">
                            <div className="footer_location">
                                <div className="footer_title">Localisation</div>
                                <ul className="locations_list">
                                    <li>
                                        <div className="location_title">
                                            57 rue de la chaux, 42160 Andrézieux Bouthéon
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Footer Opening Hours */}
                        <div className="col-lg-3 footer_col">
                            <div className="opening_hours">
                                <div className="footer_title">Horaires d'ouverture</div>
                                <ul className="opening_hours_list">
                                    <li className="d-flex flex-row align-items-start justify-content-start">
                                        <div>Lundi :</div>
                                        <div className="ml-auto">10:00 - 20:00</div>
                                    </li>
                                    <li className="d-flex flex-row align-items-start justify-content-start">
                                        <div>Mardi :</div>
                                        <div className="ml-auto">10:00 - 20:00</div>
                                    </li>
                                    <li className="d-flex flex-row align-items-start justify-content-start">
                                        <div>Mercredi :</div>
                                        <div className="ml-auto">10:00 - 20:00</div>
                                    </li>
                                    <li className="d-flex flex-row align-items-start justify-content-start">
                                        <div>Jeudi :</div>
                                        <div className="ml-auto">10:00 - 20:00</div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Footer Bar */}
            <div className="footer_bar">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="footer_bar_content d-flex flex-md-row flex-column align-items-md-center justify-content-start">
                                <div className="copyright">
                                    <span>Site créé par </span>
                                    <a href="https://www.web-caliskan.fr/" target="_blank" rel="noopener noreferrer" aria-label="Agence Web Caliskan (nouvelle fenêtre)" onClick={() => trackOutboundClick('footer_web_caliskan', 'Footer', 'https://www.web-caliskan.fr/')}>
                                        Web Caliskan
                                    </a>
                                    <span> &copy; {currentYear}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
